import React from 'react'
import About from './About'
import Discover from './Discover'
import Hero from './Hero'
import Info from './Info'

export default function Home() {
  return (
    <div>
      <Hero />
      <Info />
      <About />
      <Discover />
    </div>
  )
}
